<template>
    <v-data-table :headers="headersTabela" :items="value"
                  :hide-actions="!ehPaginado"
                  class="az-table-list tabela-itens-proposta"
                  no-data-text="Não há itens cadastrados"
                  :rows-per-page-items="[10, 25, 50]"
                  :search="buscaItem"
                  :class="{
                      'completo': (exibirExclusivo && exibirValorDeReferencia),
                      'completo-sem-referencia': (exibirExclusivo && !exibirValorDeReferencia),
                      'parcial': (!exibirExclusivo && exibirValorDeReferencia),
                      'parcial-sem-referencia': (!exibirExclusivo && !exibirValorDeReferencia)
                  }">
        <template slot="items" slot-scope="props">
            <td>
                {{ tipo === 'LOTE' ? props.item.sequencia : props.item.identificacaoSequencial }}
            </td>
            <td ref="coluna_descricao">
                <expansao-texto :tamanho="tamanho" :texto="props.item.descricao"/>
            </td>
            <td v-if="exibirExclusivo">
                {{ props.item.porteExclusivo ? 'Sim' : 'Não' }}
            </td>
            <td>
                {{ props.item.unidade }}
            </td>
            <td>
                {{ props.item.quantidade | cdCurrency('', qtdeCasasDecimais(casasDecimaisQuantidade)) }}
            </td>
            <td v-if="possuiValorReferencia && exibirValorDeReferencia" align="right">
                {{ props.item.valorUnitarioEstimado | cdCurrency(prefixo, casasDecimais)}}{{sufixo}}
            </td>
            <td>
                <v-text-field v-if="props.item.possuiLinhaFornecimento" :name="'Modelo' + props.item.itemId"
                              placeholder="Modelo"
                              maxlength="300"
                              v-model="props.item.modelo"
                              :error-messages="errors.collect('Modelo')"
                              @blur="$emit('salvarItem', props.item)"
                              :disabled="retornarRegrasDesabilitado(props.item)"/>
                <v-tooltip v-if="!props.item.possuiLinhaFornecimento" top>
                    <v-text-field slot="activator" :name="'Modelo' + props.item.itemId"
                                  placeholder="Modelo"
                                  maxlength="300"
                                  v-model="props.item.modelo"
                                  :disabled="true"/>
                    <span>
                        Esse item está bloqueado.
                    </span>
                </v-tooltip>
            </td>
            <td>
                <span v-if="props.item.possuiLinhaFornecimento">
                    <v-text-field :name="'Marca' + props.item.itemId"
                                  placeholder="Marca"
                                  maxlength="200"
                                  v-model="props.item.marca"
                                  @blur="$emit('salvarItem', props.item)"
                                  v-validate="retornarRegrasValidacaoMarca(props.item)"
                                  :disabled="retornarRegrasDesabilitado(props.item)"/>
                    <span class="mensagem-erro"
                          v-if="(props.item.tipo==='MATERIAL'
                                && (props.item.marca? props.item.marca.trim() === '' :true)
                                && (props.item.valorUnitario !== null || preenchimentoObrigatorio))">
                        Obrigatório
                    </span>
                </span>
                <v-tooltip v-if="!props.item.possuiLinhaFornecimento" top>
                    <span slot="activator">
                        <v-text-field :name="'Marca' + props.item.itemId"
                                      placeholder="Marca"
                                      maxlength="300"
                                      v-model="props.item.marca"
                                      :disabled="true"/>
                    </span>
                    <span>
                        Esse item está bloqueado.
                    </span>
                </v-tooltip>
            </td>
            <td align="right" class="alinhar-campo">
                <span v-if="props.item.possuiLinhaFornecimento">
                    <campo-monetario
                                    :name="'Valor Unitário' + props.item.itemId"
                                    v-model="props.item.valorUnitario"
                                    @blur="atualizarValorUnitario($event, props.item)"
                                    :placeholder="placeholderValor"
                                    :prefix="prefixo"
                                    :suffix="sufixo"
                                    :maxLength="18"
                                    :required="true"
                                    :disabled="regrasDesabilitado(props.item)"
                                    :precision="casasDecimais"
                                    v-validate="retornarRegrasValidacaoValorUnitario(props.item)"
                                    class="mb-0 alinhar-direita"
                    />
                    <span class="mensagem-erro"
                          v-if="preenchimentoObrigatorio && props.item.valorUnitario===null
                                || ((props.item.marca? props.item.marca.trim() !== '' :false) && props.item.valorUnitario === null)">
                        Obrigatório
                    </span>
                </span>
                <v-tooltip v-if="!props.item.possuiLinhaFornecimento" top>
                    <span slot="activator">
                        <campo-monetario
                                :name="'Valor Unitário' + props.item.itemId"
                                v-model="props.item.valorUnitario"
                                :placeholder="placeholderValor"
                                :prefix="prefixo"
                                :suffix="sufixo"
                                :maxLength="18"
                                :disabled="true"
                                :precision="casasDecimais"
                                class="mb-0 alinhar-direita"
                        />
                        <span class="mensagem-erro"
                              v-if="preenchimentoObrigatorio && props.item.valorUnitario===null
                                    || ((props.item.marca? props.item.marca.trim() !== '' :false) && props.item.valorUnitario === null)">
                            Obrigatório
                        </span>
                    </span>
                    <span>
                        Esse item está bloqueado.
                    </span>
                </v-tooltip>
            </td>
            <td align="right" v-if="menorPreco">
                {{ props.item.total | cdCurrency(prefixo, casasDecimais)}}{{sufixo}}
            </td>
        </template>
    </v-data-table>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name: 'PropostaTabelaItem',
    props: {
        value: {
            required: true,
            type: Array,
            default: () => {
                return []
            }
        },
        exibirValorDeReferencia: {type: Boolean,},
        possuiValorReferencia: {
            type: Boolean,
        },
        exibirExclusivo: {},
        preenchimentoObrigatorio: {
            default: false
        },
        propostaEnviada: {
            default: false
        },
        fornecedorPossuiPorte: {
            default: false
        },
        loteExclusivo: {
            default: false
        },
        tipo: {
            default: ''
        },
        casasDecimais: {
            type: Number,
            default: 2
        },
        termoBusca: {
            type: String,
            default: ''
        },
        exibirPaginacao: {
            type: Boolean,
            default: false
        },
        origemCompraDireta:{
            type:String,
            default:''
        },
        criterioJulgamento: {
            type:String,
            default:'MENOR_PRECO'
        },
        prefixoValor: {
            type:String,
            default:'R$'
        },
        placeholderInput: {
            type:String,
            default:'Valor'
        },
        isCriterioJulgamentoMaiorDesconto:{
            type: Boolean,
            default: false
        },
        casasDecimaisQuantidade: {
            type: Number,
            default: 2
        }
    },
    $_veeValidate: {
        validator: 'new'
    },
    watch: {
        termoBusca(termo) {
            this.atualizaValorBusca(termo)
        }
    },
    data() {
        return {
            carregou: false,
            tamanho: null,
            buscaItem: '',
            pagination: {
                sortBy: 'sequencia'
            }
        }
    },
    computed: {
        ...mapState(['loki', 'parametros']),
        prefixo() {
            if (this.prefixoValor === '%') {
                return ''
            }
            return 'R$'
        },
        sufixo() {
            if(this.prefixoValor === '%') {
                return this.prefixoValor
            }
            return ''
        },
        menorPreco() {
            if(this.criterioJulgamento === 'MENOR_PRECO') {
                return true
            }
            return false
        },
        placeholderValor() {
            if (this.placeholderInput) {
                return this.placeholderInput
            }
            return 'Valor'
        },
        headersTabela () {
            let colunas = [
                {
                    align: 'left',
                    sortable: true,
                    width: '8px',
                    class: 'primary--text',
                    text: 'Seq',
                    value: 'sequencia'
                },
                {
                    align: 'left',
                    value: 'descricao',
                    class: 'primary--text',
                    text: 'Descrição',
                    width: '30px',
                    sortable: false
                },
                ... this.exibirExclusivo ? [{
                    width: '10px',
                    sortable: false,
                    text: 'Exclusivo',
                    align: 'left',
                    class: 'primary--text',
                    value: 'porteExclusivo'
                }] : [],
                {
                    sortable: false,
                    text: 'Unidade',
                    align: 'left',
                    value: 'unidade',
                    width: '10px',
                    class: 'primary--text'
                },
                {
                    value: 'quantidade',
                    text: 'Qtd',
                    align: 'left',
                    sortable: false,
                    width: '10px',
                    class: 'primary--text'
                },
                ... this.possuiValorReferencia && this.exibirValorDeReferencia ? [{
                    text: this.menorPreco ? 'Valor Ref. Un.' : 'Ref. Unit.',
                    sortable: false,
                    align: 'right',
                    value: 'valorEstimado',
                    width: '20px',
                    class: 'primary--text'
                }] : [],
                {
                    sortable: false,
                    text: 'Modelo',
                    align: 'left',
                    width: '80px',
                    value: 'modelo',
                    class: 'primary--text'
                },
                {
                    text: 'Marca',
                    sortable: false,
                    align: 'left',
                    value: 'marca',
                    width: '80px',
                    class: 'primary--text'
                },
                {
                    sortable: false,
                    text: this.menorPreco ? 'Valor Unitário' : 'Desconto',
                    align: 'right',
                    width: '40px',
                    value: 'valorUnitario',
                    class: 'primary--text'
                },
                {
                    sortable: false,
                    text: 'Valor Total',
                    align: 'right',
                    width: '60px',
                    value: 'valorTotal',
                    class: 'primary--text'
                }
            ]
            return colunas.filter(coluna => {
                if(this.menorPreco)
                    return true
                return coluna.text !== 'Valor Total'
            })
        }
    },
    created() {
        window.addEventListener('resize', this.pegarTamanho)
        this.pegarTamanho()
    },
    methods: {
        atualizaValorBusca(termoBusca) {
            this.buscaItem = termoBusca
        },
        verificarValor(item) {
            if (item.valorUnitario >= 10000000000) {
                throw new Error('Não é possível enviar um valor acima de 10 bilhões de reais.')
            }
            this.$emit('salvarItem', item)
        },
        atualizarValorUnitario(novoValor, item) {
            item.valorUnitario = novoValor
            this.verificarValor(item)
        },
        pegarTamanho() {
            this.tamanho = .082 * window.innerWidth
        },
        retornarRegrasValidacaoMarca(item, regras = []) {
            let requerido = ''
            if (item.tipo === 'MATERIAL' && (item.valorUnitario != null || this.preenchimentoObrigatorio)){
                requerido = 'required|'
            }

            return `${requerido}${regras.join('|')}`
        },
        retornarRegrasValidacaoValorUnitario(item, regras = []) {
            let requerido = ''

            if (item.valorUnitario !== null || this.preenchimentoObrigatorio) {
                requerido = 'required|'
            }

            return `${requerido}${regras.join('|')}`
        },
        retornarRegrasDesabilitado(item) {
            const exclusivo = this.tipo === 'LOTE' ? this.loteExclusivo : item.porteExclusivo
            const itemEnviadaOuCancelado = ['ENVIADA', 'CANCELADO'].includes(item.situacao)
            const fornecedorPossuiPorteFalseOuNull = (this.fornecedorPossuiPorte === false || this.fornecedorPossuiPorte === null)
            const porteExclusivoObrigatorioProposta = this.parametros.propriedadesCompraDiretas.porteExclusivoObrigatorioProposta
            const bloqueadoPorExclusividade = fornecedorPossuiPorteFalseOuNull && porteExclusivoObrigatorioProposta && exclusivo
            const naoPossuiLinhaFornecimento = item.possuiLinhaFornecimento !== true

            return this.propostaEnviada || itemEnviadaOuCancelado || bloqueadoPorExclusividade || naoPossuiLinhaFornecimento
        },
        regrasDesabilitado(item){
            if(this.tipo === 'LOTE'){
                if(this.menorPreco)
                    return this.retornarRegrasDesabilitado(item)

                return true
            }
            return this.retornarRegrasDesabilitado(item)
        },
        ehPaginado() {
            return this.$props.exibirPaginacao && this.$props.tipo !== 'LOTE'
        }
    },
    destroyed() {
        window.removeEventListener('resize', this.pegarTamanho)
    }
}
</script>

<style lang="stylus">
    .tabela-itens-proposta
        padding 16px

        thead tr th
            padding 5px 10px !important
            font-weight bold

        td
            padding 20px 10px !important

        .mensagem-erro
            position absolute

    @media (max-width 720px)
        .tabela-itens-proposta
            padding 0

            .alinhar-campo
                text-align left

        .parcial, .completo, .parcial-sem-referencia, .completo-sem-referencia
            td:nth-of-type(1):before
                content "Sequência:"

            td:nth-of-type(2):before
                content "Descrição:"

        .parcial
            td:nth-of-type(3):before
                content "Unidade:"

            td:nth-of-type(4):before
                content "Quantidade:"

            td:nth-of-type(5):before
                content "Valor Ref. Un.:"

            td:nth-of-type(6):before
                content "Modelo:"

            td:nth-of-type(7):before
                content "Marca:"

            td:nth-of-type(8):before
                content "Valor Unitário:"

            td:nth-of-type(9):before
                content "Valor Total:"

        .parcial-sem-referencia
            td:nth-of-type(3):before
                content "Unidade:"

            td:nth-of-type(4):before
                content "Quantidade:"

            td:nth-of-type(5):before
                content "Modelo:"

            td:nth-of-type(6):before
                content "Marca:"

            td:nth-of-type(7):before
                content "Valor Unitário:"

            td:nth-of-type(8):before
                content "Valor Total:"

        .completo
            td:nth-of-type(3):before
                content "Exclusivo:"

            td:nth-of-type(4):before
                content "Unidade:"

            td:nth-of-type(5):before
                content "Quantidade:"

            td:nth-of-type(6):before
                content "Valor Ref. Un.:"

            td:nth-of-type(7):before
                content "Modelo:"

            td:nth-of-type(8):before
                content "Marca:"

            td:nth-of-type(9):before
                content "Valor Unitário:"

            td:nth-of-type(10):before
                content "Valor Total:"

        .completo-sem-referencia
            td:nth-of-type(3):before
                content "Exclusivo:"

            td:nth-of-type(4):before
                content "Unidade:"

            td:nth-of-type(5):before
                content "Quantidade:"

            td:nth-of-type(6):before
                content "Modelo:"

            td:nth-of-type(7):before
                content "Marca:"

            td:nth-of-type(8):before
                content "Valor Unitário:"

            td:nth-of-type(9):before
                content "Valor Total:"

        .texto-total
            text-align left !important

        .parcial td:nth-of-type(9)
            text-align left

        .completo td:nth-of-type(10)
            text-align left

        .parcial-sem-referencia td:nth-of-type(7)
            text-align left

        .parcial-sem-referencia td:nth-of-type(8)
            text-align left

        .completo-sem-referencia td:nth-of-type(8)
            text-align left

        .completo-sem-referencia td:nth-of-type(9)
            text-align left

        .parcial td:nth-of-type(5)
            text-align left

        .completo td:nth-of-type(6)
            text-align left
</style>
